import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'email-sent',
    templateUrl: 'email-sent.component.html',
    styleUrls: ['email-sent.component.scss']
})
export class EmailSentComponent {
    public userName: string;
    public password: string;

    constructor(private _location: Location,
                private _router: Router) { }

    public back() {
        this._router.navigate(['admin-login']);
    }
}
